module.exports = __webpack_public_path__ + "static/media/BecomeAbaron.4e2797d0.PNG";